module.exports = __webpack_public_path__ + "fonts/Roboto-700.ee7b96fa.ttf";